import ReactDOM from 'react-dom'
import { useState } from 'react'
import { SubmissionPDF } from 'apps/onboarding_client/components/Submission'

const Submission = () => {
  const [complete, setComplete] = useState(false)
  
  const pdfProps = {
    complete,
    setComplete,
    pdfPath: window.pdfPath,
    isWhiteLabeled: window.isWhiteLabeled,
    logoParams: window.logoParams,
    errorMessage: 'Oops! Looks like something went wrong loading the PDF. Please try again.',
    inline: true,
  }

  return <SubmissionPDF {...pdfProps}/>
}

ReactDOM.render(
  <Submission />,
  document.querySelector('#pdf-viewer')
)
